// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27Vxm","questions":"styles_questions__310qt","footer":"styles_footer__RhwkK"};